module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-31.2c562cac.png";